import React from 'react'
import { Check } from 'lucide-react'

const checklistItems = [
  'Verified School Badge',
  'Lead Trainer Bio & Links',
  'Curriculum Download Link',
  'Studio Gallery (8+ Photos)',
]

const GettingStarted: React.FC = () => (
  <div className="max-w-4xl mx-auto px-8 py-10">
    <nav className="mb-6">
      <ol className="flex items-center gap-2 text-sm text-gray-500">
        <li>Docs</li>
        <li>/</li>
        <li className="text-gray-900 font-medium">Getting Started</li>
      </ol>
    </nav>

    <h1 className="text-3xl font-bold text-gray-900 mb-4">
      Getting Started with Your <span className="text-primary-500">Profile</span>
    </h1>
    <p className="text-gray-600 mb-12 leading-relaxed">
      Your school profile is the first thing potential trainees see. A complete profile builds trust and helps students find the right program for them. Make sure to include all required elements.
    </p>

    <div className="flex items-start gap-4 mb-6">
      <span className="flex-shrink-0 w-10 h-10 bg-primary-500 text-white font-bold text-sm flex items-center justify-center rounded">
        01
      </span>
      <div className="flex-1">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Required Profile Elements</h2>
        <p className="text-gray-600 mb-6 leading-relaxed">
          Ensure your profile includes these key elements to get verified and attract more students.
        </p>
        <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
          <div className="grid grid-cols-2 gap-4">
            {checklistItems.map((item) => (
              <div key={item} className="flex items-center gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center">
                  <Check className="h-3.5 w-3.5 text-primary-600" />
                </div>
                <span className="text-sm font-medium text-gray-700">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default GettingStarted
